import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const MODULO = "MiPerfil";

const normalizarTexto = (texto = "") =>
  String(texto)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();

const MiPerfil = () => {
  const navigate = useNavigate();

  const [instructor, setInstructor] = useState(null);
  const [loading, setLoading] = useState(false);

  const colores = {
    fondo: "linear-gradient(135deg, #0e1319 0%, #212529 40%, #0d6efd 100%)",
    azul: "#0d6efd",
  };

  const getHeaders = () => {
    const token =
      localStorage.getItem("token") || sessionStorage.getItem("token");

    return {
      Authorization: `Bearer ${token}`,
    };
  };

  const getModuloMiPerfil = () => {
    try {
      const permisosStorage = localStorage.getItem("permisos");
      const usuarioStorage = localStorage.getItem("usuario");
      const userStorage = localStorage.getItem("user");
      const usuariosStorage = localStorage.getItem("usuarios");

      const permisosData = permisosStorage
        ? JSON.parse(permisosStorage)
        : usuarioStorage
          ? JSON.parse(usuarioStorage)
          : userStorage
            ? JSON.parse(userStorage)
            : usuariosStorage
              ? JSON.parse(usuariosStorage)
              : {};

      const modulos = Array.isArray(permisosData)
        ? permisosData
        : permisosData?.modulos ||
        permisosData?.permisos ||
        permisosData?.usuario?.modulos ||
        permisosData?.usuario?.permisos ||
        permisosData?.user?.modulos ||
        permisosData?.user?.permisos ||
        [];

      const moduloBuscado = normalizarTexto(MODULO);

      return (
        modulos.find((modulo) => {
          const nombre =
            modulo?.nombreModulo || modulo?.modulo || modulo?.nombre || "";

          return normalizarTexto(nombre) === moduloBuscado;
        }) || {}
      );
    } catch (error) {
      console.error("Error leyendo permisos MiPerfil:", error);
      return {};
    }
  };

  const moduloMiPerfil = useMemo(() => getModuloMiPerfil(), []);

  const puedeLeer =
    moduloMiPerfil?.puedeLeer === true ||
    moduloMiPerfil?.leer === true ||
    moduloMiPerfil?.read === true;

  const puedeActualizar =
    moduloMiPerfil?.puedeActualizar === true ||
    moduloMiPerfil?.actualizar === true ||
    moduloMiPerfil?.editar === true ||
    moduloMiPerfil?.update === true;

  const nombreCompleto = [
    instructor?.nombre1Instructor,
    instructor?.nombre2Instructor,
    instructor?.apellido1Instructor,
    instructor?.apellido2Instructor,
  ]
    .filter(Boolean)
    .join(" ");

  const formatearFecha = (fecha) => {
    if (!fecha) return "No registrado";
    return new Date(fecha).toLocaleDateString("es-CO");
  };

  const cargarPerfil = async () => {
    try {
      if (!puedeLeer) return;

      setLoading(true);

      const { data } = await axios.get("/api/perfil", {
        headers: getHeaders(),
      });

      if (!data?.ok) {
        Swal.fire(
          "Perfil no encontrado",
          data?.message || "No se encontró información del perfil.",
          "warning"
        );
        return;
      }

      setInstructor(data.message || {});
    } catch (error) {
      console.error(
        "Error al cargar perfil:",
        error.response?.data || error.message
      );

      if (error.response?.status === 401) {
        Swal.fire("Sesión expirada", "Ingrese nuevamente.", "warning");
        localStorage.clear();
        sessionStorage.clear();
        navigate("/");
        return;
      }

      Swal.fire(
        "Error",
        error.response?.data?.message || "No se pudo cargar el perfil.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarPerfil();
  }, [puedeLeer]);

  if (!puedeLeer) {
    return (
      <main className="container py-5">
        <section className="alert alert-warning text-center rounded-4">
          No tiene permisos para ver Mi Perfil.
        </section>

        <div className="text-center">
          <button
            className="btn btn-dark mt-3"
            onClick={() => navigate("/inicio")}
          >
            Volver al inicio
          </button>
        </div>
      </main>
    );
  }

  if (loading) {
    return (
      <main className="min-vh-100 d-flex align-items-center justify-content-center bg-body-tertiary">
        <section className="text-center">
          <div className="spinner-border text-dark"></div>
          <p className="mt-3 text-secondary">
            Cargando perfil del instructor...
          </p>
        </section>
      </main>
    );
  }

  if (!instructor) {
    return (
      <main className="container py-5">
        <section className="alert alert-warning text-center rounded-4">
          No se encontró información del perfil.
        </section>
      </main>
    );
  }

  return (
    <main className="container-fluid min-vh-90">
      <section
        className="rounded-4 shadow-sm p-4 mb-3 text-white"
        style={{ background: colores.fondo }}
      >
        <div className="row align-items-center text-center text-lg-start">
          <div className="col-lg-5">
            <h2 className="fw-bold mb-1">
              {nombreCompleto || "Instructor"}
            </h2>

            <p className="mb-0 opacity-75">
              {instructor.rolObjectId?.nombreRol || "Rol no registrado"}
            </p>
          </div>

          <div className="col-lg-7 mt-4 mt-lg-0">
            <div className="row g-2 justify-content-center justify-content-lg-end">
              {puedeActualizar && (
                <div className="col-6 col-sm-6 col-md-3 col-lg-3">
                  <button
                    type="button"
                    className="btn btn-light rounded-4 w-100 py-3 text-center shadow-sm h-100"
                    onClick={() => navigate(`/perfil/editar/${instructor._id}`)}
                  >
                    <i className="fa-solid fa-user-pen d-block fs-4 mb-2"></i>
                    <small className="fw-semibold">Editar</small>
                  </button>
                </div>
              )}

              <div className="col-6 col-sm-6 col-md-3 col-lg-3">
                <button
                  type="button"
                  className="btn btn-light rounded-4 w-100 py-3 text-center shadow-sm h-100"
                  onClick={() =>
                    navigate(`/instructor/listarcontratos/${instructor._id}`)
                  }
                >
                  <i className="fa-solid fa-file-contract d-block fs-4 mb-2"></i>
                  <small className="fw-semibold">Contratos</small>
                </button>
              </div>

              <div className="col-6 col-sm-6 col-md-3 col-lg-3">
                <button
                  type="button"
                  className="btn btn-light rounded-4 w-100 py-3 text-center shadow-sm h-100"
                  onClick={() =>
                    navigate(`/instructor/registrarfirma/${instructor._id}`)
                  }
                >
                  <i className="fa-solid fa-signature d-block fs-4 mb-2"></i>
                  <small className="fw-semibold">Firma</small>
                </button>
              </div>

              <div className="col-6 col-sm-6 col-md-3 col-lg-3">
                <button
                  type="button"
                  className="btn btn-light rounded-4 w-100 py-3 text-center shadow-sm h-100"
                  onClick={() => navigate("/inicio")}
                >
                  <i className="fa-solid fa-house d-block fs-4 mb-2"></i>
                  <small className="fw-semibold">Inicio</small>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="row g-4">
        <aside className="col-12 col-xl-4">
          <article className="bg-white border rounded-4 shadow-sm overflow-hidden">
            <div className="p-4 text-center border-bottom">
              <div
                className="mx-auto rounded-circle overflow-hidden shadow"
                style={{
                  width: 210,
                  height: 210,
                  border: `5px solid ${colores.azul}`,
                  background: "#f8f9fa",
                }}
              >
                {instructor.imgInstructor ? (
                  <img
                    src={instructor.imgInstructor}
                    alt="Instructor"
                    className="w-100 h-100"
                    style={{ objectFit: "cover" }}
                  />
                ) : (
                  <div className="h-100 d-flex align-items-center justify-content-center text-secondary">
                    <i className="fa-solid fa-user-tie fs-1"></i>
                  </div>
                )}
              </div>

              <h4 className="fw-bold mt-3 mb-1">
                {nombreCompleto || "Instructor"}
              </h4>

              <span
                className="badge rounded-pill px-3 py-2"
                style={{ background: colores.fondo, color: "#fff" }}
              >
                <i className="fa-solid fa-user-graduate me-2"></i>
                {instructor.rolObjectId?.nombreRol || "Instructor"}
              </span>
            </div>

            <div className="p-4">
              <div className="d-flex flex-column flex-md-row align-items-center text-center text-md-start gap-2 mb-3">
                <div
                  className="rounded-circle bg-light border d-flex align-items-center justify-content-center"
                  style={{ width: 42, height: 42 }}
                >
                  <i className="fa-solid fa-envelope text-dark"></i>
                </div>
                <div>
                  <div className="small text-secondary">Correo</div>
                  <div className="fw-semibold">
                    {instructor.emailInstructor || "No registrado"}
                  </div>
                </div>
              </div>

              <div className="d-flex flex-column flex-md-row align-items-center text-center text-md-start gap-2 mb-3">
                <div
                  className="rounded-circle bg-light border d-flex align-items-center justify-content-center"
                  style={{ width: 42, height: 42 }}
                >
                  <i className="fa-solid fa-phone text-dark"></i>
                </div>
                <div>
                  <div className="small text-secondary">Teléfono</div>
                  <div className="fw-semibold">
                    {instructor.telefono1Instructor || "No registrado"}
                  </div>
                </div>
              </div>

              <div className="d-flex flex-column flex-md-row align-items-center text-center text-md-start gap-2 mb-3">
                <div
                  className="rounded-circle bg-light border d-flex align-items-center justify-content-center"
                  style={{ width: 42, height: 42 }}
                >
                  <i className="fa-solid fa-id-card text-dark"></i>
                </div>
                <div>
                  <div className="small text-secondary">Documento</div>
                  <div className="fw-semibold">
                    {instructor.documentoInstructor || "No registrado"}
                  </div>
                </div>
              </div>

              <div className="d-flex flex-column flex-md-row align-items-center text-center text-md-start gap-2 mb-4">
                <div
                  className="rounded-circle bg-light border d-flex align-items-center justify-content-center"
                  style={{ width: 42, height: 42 }}
                >
                  <i className="fa-solid fa-cake-candles text-dark"></i>
                </div>
                <div>
                  <div className="small text-secondary">Cumpleaños</div>
                  <div className="fw-semibold">
                    {formatearFecha(instructor.fechanacimientoInstructor)}
                  </div>
                </div>
              </div>
            </div>
          </article>
        </aside>

        <section className="col-12 col-xl-8">
          <div className="row g-3 mb-4">
            <div className="col-6 col-md-3">
              <article className="bg-white border rounded-4 shadow-sm p-3 h-100">
                <div className="d-flex flex-column flex-md-row align-items-center justify-content-center text-center text-md-start gap-3">
                  <div
                    className="rounded-4 text-white d-flex align-items-center justify-content-center"
                    style={{
                      width: 52,
                      height: 52,
                      background: colores.fondo,
                    }}
                  >
                    <i className="fa-solid fa-user"></i>
                  </div>

                  <div>
                    <div className="small text-secondary">Identidad</div>
                    <div className="fw-bold fs-6 fs-md-5">
                      {instructor.tipodocumentoInstructor || "N/A"}
                    </div>
                  </div>
                </div>
              </article>
            </div>

            <div className="col-6 col-md-3">
              <article className="bg-white border rounded-4 shadow-sm p-3 h-100">
                <div className="d-flex flex-column flex-md-row align-items-center justify-content-center text-center text-md-start gap-3">
                  <div
                    className="rounded-4 text-white d-flex align-items-center justify-content-center"
                    style={{
                      width: 52,
                      height: 52,
                      background: colores.fondo,
                    }}
                  >
                    <i className="fa-solid fa-droplet"></i>
                  </div>

                  <div>
                    <div className="small text-secondary">Grupo RH</div>
                    <div className="fw-bold fs-6 fs-md-5">
                      {instructor.rhInstructor || "N/A"}
                    </div>
                  </div>
                </div>
              </article>
            </div>

            <div className="col-6 col-md-3">
              <article className="bg-white border rounded-4 shadow-sm p-3 h-100">
                <div className="d-flex flex-column flex-md-row align-items-center justify-content-center text-center text-md-start gap-3">
                  <div
                    className="rounded-4 text-white d-flex align-items-center justify-content-center"
                    style={{
                      width: 52,
                      height: 52,
                      background: colores.fondo,
                    }}
                  >
                    <i className="fa-solid fa-cake-candles"></i>
                  </div>

                  <div>
                    <div className="small text-secondary">Edad</div>
                    <div className="fw-bold fs-6 fs-md-5">
                      {instructor.edadInstructor || "N/A"}
                    </div>
                  </div>
                </div>
              </article>
            </div>

            <div className="col-6 col-md-3">
              <article className="bg-white border rounded-4 shadow-sm p-3 h-100">
                <div className="d-flex flex-column flex-md-row align-items-center justify-content-center text-center text-md-start gap-3">
                  <div
                    className="rounded-4 text-white d-flex align-items-center justify-content-center"
                    style={{
                      width: 52,
                      height: 52,
                      background: colores.fondo,
                    }}
                  >
                    <i className="fa-solid fa-venus-mars"></i>
                  </div>

                  <div>
                    <div className="small text-secondary">Sexo</div>
                    <div className="fw-bold fs-6 fs-md-5">
                      {instructor.sexoInstructor || "No registrado"}
                    </div>
                  </div>
                </div>
              </article>
            </div>
          </div>

          <article className="bg-white border rounded-4 shadow-sm p-3 p-md-4 mb-4">
            <div className="d-flex flex-column flex-md-row align-items-center justify-content-center justify-content-md-start gap-2 mb-2">
              <div
                className="rounded-circle d-flex align-items-center justify-content-center text-white"
                style={{
                  width: 38,
                  height: 38,
                  backgroundColor: colores.azul,
                }}
              >
                <i className="fa-solid fa-address-card"></i>
              </div>

              <h5 className="fw-bold mb-0" style={{ color: colores.azul }}>
                Datos personales
              </h5>
            </div>

            <hr />

            <div className="row g-3">
              {[
                ["Primer nombre", instructor.nombre1Instructor],
                ["Segundo nombre", instructor.nombre2Instructor],
                ["Primer apellido", instructor.apellido1Instructor],
                ["Segundo apellido", instructor.apellido2Instructor],
              ].map(([label, value]) => (
                <div className="col-12 col-md-6 col-xl-3" key={label}>
                  <div className="border rounded-4 p-3 h-100 bg-light">
                    <div className="small text-secondary text-uppercase fw-semibold mb-1 text-center text-md-start">
                      {label}
                    </div>
                    <div className="fw-bold text-dark text-center text-md-start">
                      {value || "No registrado"}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </article>

          <article className="bg-white border rounded-4 shadow-sm p-3 p-md-4 mb-4">
            <div className="d-flex flex-column flex-md-row align-items-center justify-content-center justify-content-md-start gap-2 mb-3">
              <div
                className="rounded-circle d-flex align-items-center justify-content-center text-white"
                style={{
                  width: 38,
                  height: 38,
                  backgroundColor: colores.azul,
                }}
              >
                <i className="fa-solid fa-map-location-dot"></i>
              </div>

              <h5 className="fw-bold mb-0" style={{ color: colores.azul }}>
                Contacto y ubicación
              </h5>
            </div>

            <hr />

            <div className="row g-3">
              {[
                ["Teléfono alterno", instructor.telefono2Instructor, "col-12 col-md-6 col-xl-4"],
                ["Dirección", instructor.direccionInstructor, "col-12 col-md-6 col-xl-8"],
                ["País", instructor.paisInstructor, "col-12 col-md-6 col-xl-4"],
                ["Estado", instructor.estadoInstructor, "col-12 col-md-6 col-xl-4"],
                ["Ciudad", instructor.ciudadInstructor, "col-12 col-md-6 col-xl-4"],
              ].map(([label, value, col]) => (
                <div className={col} key={label}>
                  <div className="border rounded-4 p-3 h-100 bg-light">
                    <div className="small text-secondary text-uppercase fw-semibold mb-1 text-center text-md-start">
                      {label}
                    </div>
                    <div className="fw-bold text-dark text-center text-md-start">
                      {value || "No registrado"}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </article>
        </section>
      </section>
    </main>
  );
};

export default MiPerfil;